import { useSearchParams } from 'react-router-dom';

/**
 * Where "back" goes for a project page, when somebody arrived from Project management.
 *
 * THE PROBLEM THIS SOLVES. Project management puts a board one click from the sidebar, but
 * stepping off it — to the project overview, to the roadmap — landed you on a page whose only
 * way back was the company dashboard. You had come in one door and the building offered a
 * different one.
 *
 * The links out of that page carry `?from=pm`, and this reads it. Back returns to the SAME
 * project, not to the grid: somebody who was looking at a board and glanced at its overview
 * wants the board again, not a list of every project they have.
 */
export function useProjectReturn(projectId: string | undefined) {
  const [params] = useSearchParams();
  const cameFrom = params.get('from') === 'pm';

  return {
    cameFrom,
    /** Null when they did not come that way, so nothing invents a trail that never happened. */
    backTo: cameFrom && projectId ? `/project-management?project=${projectId}` : null,
    /** Appended to links that stay inside the same journey. */
    suffix: cameFrom ? '?from=pm' : '',
  };
}
